"use client";

import { IconUser } from "@tabler/icons-react";
import React from "react";
import { useUserContext } from "../../../../providers/UserProvider";
import { useTranslations } from "../../../../helpers/translations";

export const MobileSignupAvatar = () => {
  const { currentUserAll } = useUserContext();
  const user = currentUserAll?.data?.me;
  const isLoggedIn = !!user;
  const t = useTranslations("nav");

  if (isLoggedIn) {
    return null;
  }

  return (
    <a
      href={t("footer.signup.href")}
      className="relative flex text-utility-gray-400 hover:text-white py-md px-xs"
      // replicating the event from nextjs, keep it simple
      // since the frontend in rails is deprecated and will be removed in the future
      onClick={() => {
        window.posthog?.capture("web_onboarding", {
          operation_name: "nav_mobile_avatar_click",
          application: "rails",
        });
      }}
    >
      <IconUser width={32} className="shrink-0" />
    </a>
  );
};
